import { useNavigate } from 'react-router-dom'

import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { InsuranceParamsTravelDto, InsuranceParamsTravelDto as Step1FormValues } from 'BrokerTsLib/src/dtos'
import { Step1Form } from '../../../containers/cestovko/Step1Form'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'
import { Loading } from '../../../components/Loading'
import { AxiosError } from 'axios'
import { useUpdateLastWizardStep, useSaveInsuranceParams } from '../../../hooks/useWizard'
import { WithAuth } from '../../../containers/hoc/WithAuth'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'

const _Step1 = () => {
  const navigate = useNavigate()

  const { insuranceParams, insuranceParamsId: paramsId, refetchInsuranceParams, error, isLoadingData } = useInsuranceParamsContext()
  const { mutateAsync: updateStep } = useUpdateLastWizardStep()
  const { mutateAsync: saveInsuranceParams } = useSaveInsuranceParams()

  const handleSubmit = (values: Step1FormValues) => {
    var promise = new Promise(function (resolve, reject) {
      saveInsuranceParams(values)
        .then((response) => {

          if (paramsId)
            refetchInsuranceParams()

          if (values.nextPage == 'next') {
            if ((insuranceParams?.generalParams.lastWizardStep ?? 1) == 1)
              updateStep({ paramsId: Number(response?.data), step: 2, stepsStep: 'cestovko' }).then(() => refetchInsuranceParams())
            navigate(`/cestovko/wizard/2/${response?.data}`)
          } else {
            navigate(`/cestovko/wizard/1/${response?.data}`)
          }

          resolve(response)
        })
        .catch((err: AxiosError) => {
          reject(err)
        })
        .finally(() => { })
    })

    return promise
  }

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) &&
          <StepsContent step={1}>
            <Steps icon="beach" />

            <Step1Form onSubmit={handleSubmit} data={insuranceParams as InsuranceParamsTravelDto} />
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}

export const Step1 = WithAuth(_Step1)